import { configureStore, type Middleware } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import createSocketIoMiddleware from 'redux-socket.io';
import alerts from '../feature/alertsSlice';
import dashboard from '../feature/dashboardSlice';
import rootReducer from '../reducers/root';
import socket, {
  forgetServerRoomForResync,
  rememberServerRoomForResync
} from './connectService';

// Relay any redux actions prefixed with `server/` to the socket.io server
const socketMiddleware = createSocketIoMiddleware(socket, 'server/');

// Track active `server/subscribe` rooms so they can be re-sent after a socket reconnect
const serverRoomResyncMiddleware: Middleware = () => (next) => (action: unknown) => {
  const a = action as { type?: string; room?: unknown };
  if (a.type === 'server/subscribe' && typeof a.room === 'string') {
    rememberServerRoomForResync(a.room);
  }
  if (a.type === 'server/unsubscribe' && typeof a.room === 'string') {
    forgetServerRoomForResync(a.room);
  }
  return next(action);
};

export const store = configureStore({
  reducer: {
    root: rootReducer,
    dashboard,
    alerts
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(socketMiddleware)
    .concat(serverRoomResyncMiddleware)
    .concat(logger),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
